"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _loggers = require("customer-data-tracking/loggers");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UISearchInput = _interopRequireDefault(require("UIComponents/input/UISearchInput"));

var propTypes = {
  onChange: _propTypes.default.func.isRequired,
  objectType: _ObjectTypesType.default.isRequired
};

var TimelineSearchTextInput =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TimelineSearchTextInput, _PureComponent);

  function TimelineSearchTextInput() {
    var _this;

    (0, _classCallCheck2.default)(this, TimelineSearchTextInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineSearchTextInput).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      value: '',
      active: false
    };
    return _this;
  }

  (0, _createClass2.default)(TimelineSearchTextInput, [{
    key: "handleSearchTextChange",
    value: function handleSearchTextChange(_ref) {
      var value = _ref.target.value;
      this.setState({
        value: value
      });
      this.props.onChange(value);
    }
  }, {
    key: "handleExpand",
    value: function handleExpand() {
      var _this2 = this;

      if (!this.state.active) {
        _loggers.CrmLogger.logRecordInteraction(this.props.objectType, {
          action: 'timeline filter search focused'
        });
      }

      this.setState({
        active: true
      });
      setTimeout(function () {
        _this2.__inputRef.focus();
      }, 100);
    }
  }, {
    key: "handleCollapse",
    value: function handleCollapse() {
      this.setState({
        active: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          active = _this$state.active,
          value = _this$state.value;
      var isInputVisible = active || value;
      return _react.default.createElement("div", {
        className: "searchContainer " + (isInputVisible ? 'active' : 'inactive'),
        style: {
          maxWidth: '360px'
        },
        onClick: this.handleExpand
      }, _react.default.createElement(_UISearchInput.default, {
        ref: function ref(_ref2) {
          if (_ref2) _this3.__inputRef = _ref2;
        },
        onFocus: this.handleExpand,
        onBlur: this.handleCollapse,
        minimumSearchCount: 3,
        className: "search-filter selenium-test-marker-search-filter",
        onChange: this.handleSearchTextChange,
        placeholder: _I18n.default.text('profileContentTimeline.filters.searchText.placeholder'),
        clearable: true,
        value: value,
        use: "on-dark"
      }));
    }
  }]);
  return TimelineSearchTextInput;
}(_PureComponent2.default);

TimelineSearchTextInput.propTypes = propTypes;
var _default = TimelineSearchTextInput;
exports.default = _default;
module.exports = exports.default;